const Constants = [
  // User Management
  'USER_MANAGEMENT_GET_USERS_LOADING',
  'USER_MANAGEMENT_GET_USERS_SUCCESS',
  'USER_MANAGEMENT_SET_USER_PFOFILE_PROPERTIES',
  'USER_MANAGEMENT_USER_PFOFILE_INIT',
  'USER_MANAGEMENT_GET_USERS_FAIL',
  'USER_MANAGEMENT_GET_CURRENT_USER_INFO_LOADING',
  'USER_MANAGEMENT_GET_CURRENT_USER_INFO_SUCCESS',
  'USER_MANAGEMENT_GET_CURRENT_USER_INFO_FAIL',
  'USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_LOADING',
  'USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_SUCCESS',
  'USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_FAIL',
  'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_LOADING',
  'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_SUCCESS',
  'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_FAIL',
  'USER_MANAGEMENT_CURRENT_USER_INIT',
  'USER_MANAGEMENT_EDITABLE_USER_LOAD',
  'USER_MANAGEMENT_SET_CURRENT_USER_EMAIL',
  'USER_MANAGEMENT_SET_CURRENT_USER_NAME',
  'USER_MANAGEMENT_SET_CURRENT_USER_PROPERTIES',
  'USER_MANAGEMENT_SET_EDITABLE_USER_PERMISSION',
  'USER_MANAGEMENT_SET_CURRENT_USER_PERMISSIONS',
  'USER_MANAGEMENT_SET_EDITABLE_USER_LOADING_STATE',
  'USER_MANAGEMENT_INIT_INVITATION',
  'USER_MANAGEMENT_SET_CURRENT_USER_AVAILABLE_PROPERTIES',
  'USER_MANAGEMENT_GET_APPLICATION_PERMISSIONS_LOADING',
  'USER_MANAGEMENT_GET_APPLICATION_PERMISSIONS_SUCCESS',
  'USER_MANAGEMENT_GET_APPLICATION_PERMISSIONS_FAIL',
];

const DispatchConstants = Constants.reduce((accumulator: Record<string, string>, value: string) => {
  accumulator[value] = value;
  return accumulator;
}, {});

export default DispatchConstants;
